export enum RecipientsFilterNames {
  NAME = 'name',
}
